import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

//MaterialUI Imports
import { Button, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

//Icon Imports
import SaveIcon from '@mui/icons-material/Save';
import SellIcon from '@mui/icons-material/Sell';

//Third Party Import
import { useFormik } from 'formik';
import * as Yup from 'yup';

//Project Imports
import useSalesRecordService from 'services/useSalesRecordService';
import useEmployeeService from 'services/useEmployeeService';

const SalesRecodsForm = (props) => {
    //Constants
    const navigate = useNavigate();
    const { onSave, onCancel, selectedSalesRecord } = props;
    const { addSalesRecord, updateSalesRecord } = useSalesRecordService();
    const { getEmployee } = useEmployeeService();
    const { userId } = useSelector((state) => state.userReducer);

    //States
    const [loading, setLoading] = useState();
    const [employee, setEmployee] = useState([]);
    const [currentSkipValue, setCurrentSkipValue] = useState(0);
    const pageSize = 50;

    //methods
    const getEmployeeList = () => {
        getEmployee(currentSkipValue, pageSize)
            .then((response) => {
                console.log(response);
                if (response.status == 200) {
                    setEmployee(response.data.users);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        getEmployeeList();
    }, []);

    const formik = useFormik({
        initialValues: {
            id: selectedSalesRecord.id,
            date:
                selectedSalesRecord.date != undefined || selectedSalesRecord.date != null
                    ? new Date(selectedSalesRecord.date.toString() + 'Z').toISOString().split('T')[0]
                    : new Date().toISOString().split('T')[0],
            soldBy: selectedSalesRecord.soldBy,
            recordedBy: userId,
            note: selectedSalesRecord.note
        },
        validationSchema: Yup.object({
            //soldBy: Yup.number(),
            //recordedBy: Yup.number().required('Record is required'),
            note: Yup.string().max(100, 'Note must be 100 characters or less')
        }),
        onSubmit: (values) => {
            console.log(values);
            setLoading(true);
            if (selectedSalesRecord.id != 0) {
                updateSalesRecord(selectedSalesRecord.id, values)
                    .then((response) => {
                        if (response.status === 200) {
                            onSave();
                            onCancel();
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setLoading(false);
                    });
            } else {
                addSalesRecord(values)
                    .then((response) => {
                        console.log(response);
                        if (response.status === 200) {
                            setLoading(false);
                            if (response.data.newId != undefined) {
                                navigate('/sales-details?Id=' + response.data.newId);
                            }
                        } else {
                            setLoading(false);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        setLoading(false);
                    });
            }
        }
    });

    return (
        <>
            <Grid align="center">
                {selectedSalesRecord.id === 0 ? (
                    <Stack direction="row" spacing={2} sx={{ marginX: 'auto', alignItems: 'center' }}>
                        <SellIcon fontSize="medium" color="primary" />
                        <Typography variant="h4">Add New Sales Record</Typography>
                    </Stack>
                ) : (
                    <Stack direction="row" spacing={2} sx={{ marginX: 'auto', alignItems: 'center' }}>
                        <SellIcon fontSize="medium" color="primary" />
                        <Typography variant="h4">Edit Sales Record Details</Typography>
                    </Stack>
                )}
            </Grid>
            <Divider sx={{ marginY: 3 }} />
            <Grid>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                type="date"
                                name="date"
                                label="Product date"
                                onChange={formik.handleChange}
                                value={formik.values.date}
                                fullWidth
                                error={formik.touched.date && Boolean(formik.errors.date)}
                                helperText={formik.touched.date && formik.errors.date}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item sm={6} xs={12}>
                            <Stack spacing={1}>
                                <FormControl fullWidth>
                                    <InputLabel id="employee-select-label">Sold By</InputLabel>
                                    <Select
                                        labelId="employee-select-label"
                                        id="employee-select"
                                        label="Sold By"
                                        name="soldBy"
                                        onChange={formik.handleChange}
                                        value={formik.values.soldBy}
                                        fullWidth
                                        error={formik.touched.soldBy && Boolean(formik.errors.soldBy)}
                                        helperText={formik.touched.soldBy && formik.errors.soldBy}
                                    >
                                        {employee?.map((data, index) => (
                                            <MenuItem key={index} value={data.id}>
                                                {data.firstName} {data.middleName} {data.lastName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Stack>
                        </Grid>
                        {/* <Grid item sm={6} xs={12}>
                            <TextField
                                name="recordedBy"
                                label="Recorded By"
                                onChange={formik.handleChange}
                                value={formik.values.recordedBy}
                                fullWidth
                                error={formik.touched.recordedBy && Boolean(formik.errors.recordedBy)}
                                helperText={formik.touched.recordedBy && formik.errors.recordedBy}
                            />
                        </Grid> */}

                        <Grid item xs={12}>
                            <TextField
                                name="note"
                                label="Note"
                                onChange={formik.handleChange}
                                value={formik.values.note}
                                fullWidth
                                multiline
                                rows={3}
                                error={formik.touched.note && Boolean(formik.errors.note)}
                                helperText={formik.touched.note && formik.errors.note}
                            />
                        </Grid>
                    </Grid>

                    <Divider sx={{ marginY: 3 }} />
                    <Grid>
                        <LoadingButton loading={loading} variant="contained" type="submit" startIcon={<SaveIcon />}>
                            Save
                        </LoadingButton>
                        <LoadingButton variant="outlined" sx={{ marginLeft: 2 }} onClick={onCancel}>
                            {' '}
                            Cancel
                        </LoadingButton>
                    </Grid>
                </form>
            </Grid>
        </>
    );
};

export default SalesRecodsForm;
